import { Component } from 'react';
import { IconLoader } from 'common/IconLoader';
import './Checkbox.css';

/* Radio buttons from Soyong's icons
    props:
        onChange  - function called when checkbox is clicked
        isChecked - whether the component is checked. Must keep track of state in parent 
*/
class Checkbox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isCheckboxHover: false
    };
  }

  render() {
    return (
      <div
        className="Checkbox_Div"
        onClick={this.props.onChange}
        onMouseEnter={() => this.setState({ isCheckboxHover: true })}
        onMouseLeave={() => this.setState({ isCheckboxHover: false })}
      >
        <input
          type="checkbox"
          checked={this.props.isChecked === true}
          onChange={() => {
            /* This is a controlled component, but the parent handles state and passes it as a prop, and onclick is handled on 
                               surrounding div. However, this function needs to exist to suppress a warning.  */
          }}
        />
        <span className={'Checkbox_Span'}>
          {this.props.isChecked ? (
            <img
              src={
                this.props.disabled || this.props.default
                  ? this.props.disabled
                    ? IconLoader.icon_checkbox_unchecked_disabled
                    : IconLoader.icon_checkbox_checked_disabled
                  : !this.props.blueCheckbox
                  ? IconLoader.icon_checkbox_checked
                  : IconLoader.icon_bluecheckbox_checked
              }
              alt={'checkbox checked'}
            />
          ) : !this.state.isCheckboxHover ? (
            <img
              src={
                this.props.disabled
                  ? IconLoader.icon_checkbox_unchecked_disabled
                  : !this.props.blueCheckbox
                  ? IconLoader.icon_orange_checkbox_not_checked_disabled
                  : IconLoader.icon_checkbox_unchecked
              }
              alt={'checkbox unchecked'}
            />
          ) : (
            <img
              src={
                this.props.disabled
                  ? IconLoader.icon_orange_checkbox_not_checked_disabled
                  : IconLoader.icon_checkbox_checked_hover
              }
              alt={'checkbox unchecked'}
            />
          )}
        </span>
      </div>
    );
  }
}

export default Checkbox;
